import type { IamApi } from '@ipen-portal/backstage-plugin-iam-backend';
import type { TRPCOptionsProxy } from '@ipen-portal/plugin-trpc-react';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const iamApiRef = createApiRef<TRPCOptionsProxy<IamApi>>().with({
  id: 'plugin.iam.api',
});
